import PropTypes from 'prop-types';

import writing from 'assets/writing.svg';

import Header from './Header';
import ProductForm from './ProductForm';

const ReviewContext = ({
  handleSubmitReview,
  isFormValid,
  productDescription,
  setProductDescription,
  title,
  setTitle,
  isSubmitting,
  hasTAMMGuideline,
  setHasTAMMGuideline,
}) => (
  <div
    className="flex-[3] max-w-xl 2xl:max-w-[632px] bg-white rounded-2xl shadow-lg flex flex-col mx-8"
  >
    <div className="flex flex-col flex-grow p-7 2xl:p-10 gap-10">
      <Header
        icon={writing}
        title="Add your context"
        enabled
      />

      <ProductForm
        productDescription={productDescription}
        setProductDescription={setProductDescription}
        title={title}
        setTitle={setTitle}
        hasTAMMGuideline={hasTAMMGuideline}
        setHasTAMMGuideline={setHasTAMMGuideline}
      />

      <div className="flex items-end mt-auto h-10 gap-10">
        {/* Submit Button */}
        <button
          disabled={!isFormValid || isSubmitting}
          onClick={handleSubmitReview}
          className={`px-5 py-2.5 text-sm font-medium rounded-lg transition-colors ml-auto ${
            isFormValid && !isSubmitting
              ? 'bg-primary-500 text-white cursor-pointer hover:bg-primary-600'
              : 'bg-gray-100 text-gray-600 cursor-not-allowed'
          }`}
          style={{ minWidth: '158px', height: '40px', padding: '10px 20px' }}
        >
          Submit for review
        </button>
      </div>
    </div>
  </div>
);

ReviewContext.propTypes = {
  handleSubmitReview: PropTypes.func.isRequired,
  isFormValid: PropTypes.bool.isRequired,
  productDescription: PropTypes.string.isRequired,
  setProductDescription: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  setTitle: PropTypes.func.isRequired,
  hasTAMMGuideline: PropTypes.bool.isRequired,
  setHasTAMMGuideline: PropTypes.func.isRequired,
};

export default ReviewContext;
